'use client';

// This is the only allowed place for sendGTMEvent
// eslint-disable-next-line no-restricted-imports
import { sendGTMEvent } from '@next/third-parties/google';
import type { DataLayerEvent } from './types';

export * from './types';

type DataLayerEventOptional = DataLayerEvent | undefined | false | null;

export const pushDataLayerEvent = (data?: DataLayerEventOptional) => {
  if (data) {
    sendGTMEvent(data);
    console.log(`DataLayer event ${data.event}`, data);
  }
};
